import {
  Directive,
  ElementRef,
  forwardRef,
  Inject,
  Input,
  Renderer2,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[uppercase],[uppercase][ngModel]',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    '(input)': 'input($event.target.value, $event.target)',
    '(blur)': 'focusout($event.target.value, $event.target)',
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UpperCaseDirective),
      multi: true,
    },
  ],
})
export class UpperCaseDirective {
  @Input() charOnly: boolean;
  @Input() alphaNumOnly: boolean;
  @Input() justNumber: boolean;
  @Input() appNomeEmpresa: boolean;
  @Input() removeSpaceBeginEnd: boolean;

  constructor(
    @Inject(Renderer2) private renderer: Renderer2,
    @Inject(ElementRef) private element: ElementRef
  ) {}

  writeValue(value: any) {
    if (value === undefined || value === null) {
      this.propagateChange(null);
      this.renderer.setProperty(this.element.nativeElement, 'value', '');
    } else {
      this.input(value);
    }
  }

  // tslint:disable
  propagateChange = (_: any) => {
    // This is intentional
  };
  // tslint:enable

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  // tslint:disable
  public onTouched: any = () => {
    // This is intentional
  };
  // tslint:enable

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  input(val, event?) {
    let retVal = val.toUpperCase();
    if (this.removeSpaceBeginEnd) {
      retVal = retVal.replace(/^\s+/, '');
    }
    if (this.charOnly) {
      retVal = retVal.replace(/[^\w\s/]|[\\//"]|_|\d/gi, '');
    }
    if (this.alphaNumOnly) {
      retVal = retVal
        .replace(new RegExp(/[ÁÂÀÄÃ]/, 'g'), 'A')
        .replace(new RegExp(/[ÉÊÈË]/, 'g'), 'E')
        .replace(new RegExp(/[ÍÎÌÏ]/, 'g'), 'I')
        .replace(new RegExp(/[ÓÔÒÖÕ]/, 'g'), 'O')
        .replace(new RegExp(/[ÚÛÙÜ]/, 'g'), 'U')
        .replace(new RegExp(/[Ç]/, 'g'), 'C')
        .replace(new RegExp(/[Ñ]/, 'g'), 'N')
        .replace(new RegExp(/[^A-Z0-9 ]/, 'g'), '');
    }
    if (this.justNumber) {
      retVal = retVal.replace(/[^0-9]/g, '');
    }
    if (this.appNomeEmpresa) {
      retVal = retVal.replace(/[^\w\s]|[\\//"]|_|[|,"/]/gi, '');
    }
    this.propagateChange(retVal);
    this.renderer.setProperty(this.element.nativeElement, 'value', retVal);

    // tslint:disable
    setTimeout(() => {
      if (event !== undefined) {
        event.setSelectionRange(retVal.length, retVal.length);
      }
    }, 0);
    // tslint:enable
  }

  focusout(val, event) {
    let retVal = val.toUpperCase();
    if (this.removeSpaceBeginEnd) {
      retVal = retVal.trim();
      retVal = this.removeMultipleSpaces(retVal);
      retVal = this.removeSpecialChars(retVal);
      this.propagateChange(retVal);
      this.renderer.setProperty(this.element.nativeElement, 'value', retVal);
    }
    this.onTouched();
  }

  removeMultipleSpaces(val) {
    return val.replace(/\s+/g, ' ');
  }

  removeSpecialChars(val) {
    return val.replace(/[^\w\s/]|[\\//"]|_|\d/gi, '');
  }
}
